import { t } from "ttag";

import type { ShortcutOption } from "metabase/querying/filters/types";

import type { TypeOption } from "./types";

const DAY_WEEK_SHORTCUT_OPTIONS: ShortcutOption[] = [
  {
    label: t`Өнөөдөр`,
    shortcut: "today",
    value: {
      type: "relative",
      value: 0,
      unit: "day",
    },
  },
  {
    label: t`Өчигдөр`,
    shortcut: "yesterday",
    value: {
      type: "relative",
      value: -1,
      unit: "day",
    },
  },
  {
    label: t`Өмнөх долоо хоног`,
    shortcut: "previous-week",
    value: {
      type: "relative",
      value: -1,
      unit: "week",
    },
  },
  {
    label: t`Өмнөх 7 өдөр`,
    shortcut: "previous-7-days",
    value: {
      type: "relative",
      value: -7,
      unit: "day",
    },
  },
  {
    label: t`Өмнөх 30 өдөр`,
    shortcut: "previous-30-days",
    value: {
      type: "relative",
      value: -30,
      unit: "day",
    },
  },
];

const MONTH_SHORTCUT_OPTIONS: ShortcutOption[] = [
  {
    label: t`Өмнөх сар`,
    shortcut: "previous-month",
    value: {
      type: "relative",
      value: -1,
      unit: "month",
    },
  },
  {
    label: t`Өмнөх 3 сар`,
    shortcut: "previous-3-months",
    value: {
      type: "relative",
      value: -3,
      unit: "month",
    },
  },
  {
    label: t`Өмнөх 12 сар`,
    shortcut: "previous-12-months",
    value: {
      type: "relative",
      value: -12,
      unit: "month",
    },
  },
];

export const SHORTCUT_OPTION_GROUPS: ShortcutOption[][] = [
  DAY_WEEK_SHORTCUT_OPTIONS,
  MONTH_SHORTCUT_OPTIONS,
];

export const TYPE_OPTIONS: TypeOption[] = [
  {
    label: t`Огноо сонгох`,
    type: "specific",
    operators: ["=", "<", ">", "between"],
  },
  {
    label: t`Харьцангуй огноо`,
    type: "relative",
    operators: [],
  },
  {
    label: t`Хасах`,
    type: "exclude",
    operators: ["!=", "is-null", "not-null"],
  },
];
